import Select from 'react-select';

const SELECT_STYLES = {
    container: (base) => ({ ...base, minWidth: '220px', flex: '1 1 220px', fontSize: '14px' }),
    menu: (base) => ({ ...base, zIndex: 30 }),
};

// One searchable dropdown (type to filter, then pick). `people` are { id, name } and already A–Z by last name.
const PersonPicker = ({ id, label, people, value, onChange, exclude = [], placeholder = 'Choose…', disabled = false }) => {
    const options = (people || []).filter((p) => !exclude.includes(p.id)).map((p) => ({ value: p.id, label: p.name }));
    const selected = options.find((o) => o.value === value) || null;
    return (
        <Select
            inputId={id}
            aria-label={label}
            classNamePrefix="person-picker"
            options={options}
            value={selected}
            placeholder={placeholder}
            isDisabled={disabled}
            isSearchable
            noOptionsMessage={() => 'No matches'}
            onChange={(o) => onChange(o ? o.value : '')}
            styles={SELECT_STYLES}
        />
    );
};

export default PersonPicker;
